import React, { useEffect, useState, useRef } from "react";
import {
  Plus,
  Upload,
  Search,
  TicketsPlane,
  ShieldCheck,
  FileText,
  Info,
  Download,
  ShieldUser,
  Calendar,
  FilePen,
  ShieldOff,
} from "lucide-react";
import DatePicker from "react-datepicker";
import { Modal, Button } from "react-bootstrap";
import "./Css/IPassModule.css";
import GreyArrow from "../assets/greyLeftAr.png";
import Header from "./Header";
import {
  get_car_ipass_data,
  delete_car_ipass_data,
  save_car_ipass_data,
  reactivate_ipass_car,
  server_post_data,
  assign_ipass_car,
  unassign_ipass_car,
  change_ipass_status,
  upload_ipass_excel_data,
  get_drives_data_payment,
} from "../ServiceConnection/serviceconnection.js";
import {
  check_vaild_save,
  combiled_form_data,
  handleError,
  handleSuccessSession,
  mondayDayYearFormat,
} from "../CommonJquery/CommonJquery.js";
import Loader from "./Loader.js";
import { useNavigate } from "react-router-dom";
const ManageIPasses = ({ showSection }) => {
  const navigate = useNavigate();
  // Dummy data for I-Passes
  const [ipassData, setIpassData] = useState([]);
  const [ipassDataFilter, setIpassDataFilter] = useState([]);
  const [ipassDataFilter1, setIpassDataFilter1] = useState([]);
  const [dynaicimage, setDynaicimage] = useState(null);
  // Dummy data for vehicles

  // State for modals
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [assignModalOpen, setAssignModalOpen] = useState(false);
  const [addIPassModalOpen, setAddIPassModalOpen] = useState(false);
  const [selectedIPass, setSelectedIPass] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [showValidationModal, setShowValidationModal] = useState(false);
  const [validationMessage, setValidationMessage] = useState("");
  const [successAlert, setSuccessAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [carData, setCarData] = useState([]);
  const [carDataSelected, setCarDataSelected] = useState("");
  const [carDataSelectedError, setCarDataSelectedError] = useState("");
  const [CarAssignNotes, setCarAssignNotes] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [driverData, setDriverData] = useState([]);

  // State for activation toggle confirmation
  const [showActivationConfirm, setShowActivationConfirm] = useState(false);
  const [ipassToToggle, setIpassToToggle] = useState(null);
  const [newActivationStatus, setNewActivationStatus] = useState(null);

  // State for Add I-Pass form
  const [formData, setFormData] = useState({
    ipassNumber: "",
    ipassStatus: "",
    ipassNotes: "",
  });

  // Helper function to get badge class based on status
  const getBadgeClass = (status) => {
    switch (status) {
      case 1:
        return "ipass-badge-available";
      case 2:
        return "ipass-badge-assigned";
      case 0:
        return "ipass-badge-lost";
      default:
        return "";
    }
  };

  // Helper function to format status text
  const formatStatus = (status) => {
    // return status.charAt(0).toUpperCase() + status.slice(1);
  };

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    master_data_get(0, 0, 0);
    master_data_get_drivers();
  }, []);
  // console.log(startDate);
  const master_data_get = async (flag_status, filter1, filter2) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("flag_status", flag_status);
    fd.append("status", filter1);
    fd.append("types", filter2);
    await server_post_data(get_car_ipass_data, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          // In master_data_get, REPLACE the two setIpassData lines:
          setIpassDataFilter(Response.data.message.pass_data);
          setIpassDataFilter1(Response.data.message);
          // Re-apply search if active
          const currentSearch = searchRef.current;
          if (currentSearch) {
            setIpassData(
              Response.data.message.pass_data.filter((ipass) =>
                ipass.ipass_id.toLowerCase().includes(currentSearch),
              ),
            );
          } else {
            setIpassData(Response.data.message.pass_data);
          }
          setIpassData(Response.data.message.pass_data);
          console.log(Response.data.message);
          setCarData(Response.data.message.car_data);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  // Statistics data computed from ipassData
  const statsData = {
    total: ipassData.length,
    available: ipassDataFilter1?.pass_available,
    assigned: ipassDataFilter1?.pass_assigned,
    lost: ipassDataFilter1?.pass_deactive,
    unassigned: ipassDataFilter1?.not_assigned_booking,
    notTolls: ipassDataFilter1?.not_toll,
    OfficeUseTolls: ipassDataFilter1?.officeusetolls,
  };

  function formatDate(dateObj) {
    // console.log(dateObj);
    const year = dateObj.getFullYear();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
    const day = dateObj.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const master_data_get_drivers = async () => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    await server_post_data(get_drives_data_payment, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setDriverData(Response.data.message.driver_data);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  // Handle Add I-Pass form submission
  const handleAddIPassSubmit = async (e) => {
    e.preventDefault();

    // Example validation
    if (formData.ipassNumber.length < 5) {
      setValidationMessage("I-Pass number must be at least 5 characters long.");
      setShowValidationModal(true);
      return;
    }

    // Simulating a server check for duplicate I-Pass numbers
    if (formData.ipassNumber === "12345") {
      setValidationMessage(
        "This I-Pass number already exists in the system. Please enter a unique number.",
      );
      setShowValidationModal(true);
      return;
    }

    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("ipass_no", formData.ipassNumber);
    fd.append("status", formData.ipassStatus);
    fd.append("notes", formData.ipassNotes);
    fd.append("ipass_date", formatDate(startDate));
    await server_post_data(save_car_ipass_data, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          master_data_get(0, 0, 0);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });

    // Show success message
    setSuccessMessage("I-Pass added successfully!");
    setSuccessAlert(true);

    // Close modal
    setAddIPassModalOpen(false);

    // Reset form
    setFormData({
      ipassNumber: "",
      ipassStatus: "",
      ipassNotes: "",
    });

    // Auto hide success alert after 5 seconds
    setTimeout(() => {
      setSuccessAlert(false);
    }, 5000);
  };

  // Handle form reset
  const handleCancel = () => {
    // Reset form
    setFormData({
      ipassNumber: "",
      ipassStatus: "",
      ipassNotes: "",
    });
  };

  // Handle Assign I-Pass click
  const handleAssignClick = (ipassNumber) => {
    setCarDataSelectedError("");
    setSelectedIPass(ipassNumber);
    setAssignModalOpen(true);
  };

  // Handle file selection
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
    }
  };

  // Handle Upload Data submission
  const handleUploadSubmit = (e) => {
    e.preventDefault();
    // Simulate upload
    // console.log(
    //   "Uploading file for I-Pass:",
    //   document.getElementById("selectIPass").value
    // );

    // Show success message
    setSuccessMessage("File uploaded successfully!");
    setSuccessAlert(true);

    // Close modal
    setUploadModalOpen(false);
    setSelectedFile(null);

    // Auto hide success alert after 5 seconds
    setTimeout(() => {
      setSuccessAlert(false);
    }, 5000);
  };

  // Handle Assign I-Pass submission
  const handleAssignSubmit = async (e) => {
    if (carDataSelected === "") {
      setCarDataSelectedError("Please select a vehicle to assign the I-Pass.");
      return;
    }
    e.preventDefault();
    const selectedVehicleId = document.getElementById("selectVehicle").value;
    const selectedVehicle = carData.find(
      (v) => v.id === parseInt(selectedVehicleId),
    );

    // Update the ipass data with the new assignment
    const updatedIpassData = ipassData.map((ipass) => {
      if (ipass.ipassNumber === selectedIPass) {
        return {
          ...ipass,
          status: "assigned",
          assignedCar: `${selectedVehicle.code} (${selectedVehicle.model})`,
          assignedDate: new Date().toLocaleDateString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
          }),
        };
      }
      return ipass;
    });

    setIpassData(updatedIpassData);
    // Show success message
    setSuccessMessage(
      `I-Pass ${selectedIPass.ipass_id} successfully assigned to vehicle!`,
    );
    // setSuccessAlert(true);
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("ipass_no", selectedIPass.ipass_id);
    fd.append("ipass_id", selectedIPass.primary_id);
    fd.append("car_id", carDataSelected);
    fd.append("notes", CarAssignNotes);
    await server_post_data(assign_ipass_car, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          master_data_get(0, 0, 0);
          setCarDataSelectedError("");
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });

    // Close modal
    setAssignModalOpen(false);

    // Auto hide success alert after 5 seconds
    setTimeout(() => {
      setSuccessAlert(false);
    }, 5000);
  };

  // Handle unassign
  const handleUnassign = async (ipassNumber) => {
    const updatedIpassData = ipassData.map((ipass) => {
      if (ipass.ipassNumber === ipassNumber) {
        return {
          ...ipass,
          status: "available",
          assignedCar: null,
          assignedDate: null,
        };
      }
      return ipass;
    });

    setIpassData(updatedIpassData);

    // Show success message
    setSuccessMessage(`I-Pass ${ipassNumber} successfully unassigned!`);
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("ipass_id", ipassNumber);
    await server_post_data(unassign_ipass_car, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          master_data_get(0, 0, 0);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
    setSuccessAlert(true);

    // Auto hide success alert after 5 seconds
    setTimeout(() => {
      setSuccessAlert(false);
    }, 5000);
  };

  // Handle toggle activation
  const handleToggleActivation = (ipass, newStatus) => {
    // Show confirmation modal for both activation and deactivation
    setIpassToToggle(ipass);

    setNewActivationStatus(newStatus);
    setShowActivationConfirm(true);
  };

  // Process the activation toggle after confirmation
  const processActivationToggle = async (ipass, newStatus) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("ipass_id", ipass.primary_id);

    // If activating (reactivating)
    if (newStatus === 1) {
      fd.append("status", 1);
      await server_post_data(reactivate_ipass_car, fd)
        .then((Response) => {
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            master_data_get(0, 0, 0);
            setSuccessMessage(
              `I-Pass ${ipass.ipass_id} successfully activated!`,
            );
            setSuccessAlert(true);
          }
          setshowLoaderAdmin(false);
        })
        .catch((error) => {
          handleError("network");
          setshowLoaderAdmin(false);
        });
    }
    // If deactivating
    else if (newStatus === 0) {
      // Assuming there's an API endpoint for deactivating, or you can use the same endpoint
      // with a different parameter. Adjust as needed based on your API.
      fd.append("status", 0); // Assuming 0 means inactive
      await server_post_data(change_ipass_status, fd) // You might need a different endpoint here
        .then((Response) => {
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            master_data_get(0, 0, 0);
            setSuccessMessage(
              `I-Pass ${ipass.ipass_id} successfully deactivated!`,
            );
            setSuccessAlert(true);
          }
          setshowLoaderAdmin(false);
        })
        .catch((error) => {
          handleError("network");
          setshowLoaderAdmin(false);
        });
    }

    // Auto hide success alert after 5 seconds
    setTimeout(() => {
      setSuccessAlert(false);
    }, 5000);
  };
  const handleSaveChangesdynamic = async (form_data, url_for_save) => {
    let vaild_data = check_vaild_save(form_data);
    if (vaild_data) {
      setshowLoaderAdmin(true);
      let fd_from = combiled_form_data(form_data, dynaicimage);
      await server_post_data(url_for_save, fd_from)
        .then((Response) => {
          setshowLoaderAdmin(false);
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            handleSuccessSession(Response.data.message, "/Manage-Ipass");
          }
        })
        .catch((error) => {
          setshowLoaderAdmin(false);
        });
    }
  };

  // Handle delete
  const handleDelete = async (ipassNumber) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("pass_id", ipassNumber);
    await server_post_data(delete_car_ipass_data, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          master_data_get(0, 0, 0);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });

    // Show success message
    setSuccessMessage(`I-Pass ${ipassNumber} deleted successfully!`);
    setSuccessAlert(true);

    // Auto hide success alert after 5 seconds
    setTimeout(() => {
      setSuccessAlert(false);
    }, 5000);
  };
  // const handleFilter1 = (value) => {
  //   master_data_get(1, value, 0);
  // };
  // const handleFilter2 = (value) => {
  //   master_data_get(2, 0, value);
  // };
  const handleFilter1 = (value) => {
    setCurrentPage(1);
    master_data_get(1, value, 0);
  };

  // REPLACE handleFilter2:
  const handleFilter2 = (value) => {
    setCurrentPage(1);
    master_data_get(2, 0, value);
  };

  // const handlesearchChange = (e) => {
  //   const searchValue = e.target.value.toLowerCase();
  //   if (searchValue === "") {
  //     setIpassData(ipassDataFilter); // Reset to original data if search is empty
  //     return;
  //   }
  //   const filteredData = ipassData.filter(
  //     (ipass) =>
  //       ipass.ipass_id.toLowerCase().includes(searchValue) ||
  //       (ipass.car_detail &&
  //         ipass.car_detail["car_name"].toLowerCase().includes(searchValue))
  //   );
  //   setIpassData(filteredData);
  // };
  // Add this ref near your other state declarations:
  const searchRef = useRef("");

  // Update handlesearchChange to track the value:
  const handlesearchChange = (e) => {
    const searchValue = e.target.value.toLowerCase();
    searchRef.current = searchValue;
    setCurrentPage(1);
    if (searchValue === "") {
      setIpassData(ipassDataFilter);
      return;
    }
    const filteredData = ipassDataFilter.filter((ipass) =>
      ipass.ipass_id.toLowerCase().includes(searchValue),
    );
    setIpassData(filteredData);
  };

  // Add confirmation modal states
  const [showConfirmUnassign, setShowConfirmUnassign] = useState(false);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [selectedIPassAction, setSelectedIPassAction] = useState(null);

  // Add these state variables after other useState declarations
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  // Add this pagination logic after your filter handlers
  // Get paginated data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems =
    ipassData && ipassData.length > 0
      ? ipassData.slice(indexOfFirstItem, indexOfLastItem)
      : [];
  const totalPages =
    ipassData && ipassData.length > 0
      ? Math.ceil(ipassData.length / itemsPerPage)
      : 0;

  // Handler for page changes
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Render pagination buttons
  const renderPaginationButtons = () => {
    const buttons = [];

    // Previous button
    buttons.push(
      <li className="cust_hist_page_item" key="prev">
        <button
          className="cust_hist_page_link cust_hist_page_prev"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <span className="sr-only">Previous</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>,
    );

    // Page buttons
    // Show max 5 page buttons with current page in the middle when possible
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    // Adjust startPage if endPage is at maximum
    if (endPage === totalPages) {
      startPage = Math.max(1, endPage - 4);
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <li className="cust_hist_page_item" key={i}>
          <button
            className={`cust_hist_page_link ${
              currentPage === i ? "cust_hist_page_active" : ""
            }`}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </button>
        </li>,
      );
    }

    // Next button
    buttons.push(
      <li className="cust_hist_page_item" key="next">
        <button
          className="cust_hist_page_link cust_hist_page_next"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
        >
          <span className="sr-only">Next</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>,
    );

    return buttons;
  };

  const downloadCSV = () => {
    const headers = [
      "Create Date",
      "I-pass Number",
      "Assigned Car",
      "Vehicle Number",
      "Status",
    ];

    const rows = ipassData.map((ipass) => [
      ipass.ipass_date || "",
      ipass.ipass_id || "",
      ipass?.car_detail?.car_name || "",
      ipass?.car_detail?.car_tagline || "",
      ipass.ipass_status === 2 ? "Active" : "Inactive",
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows].map((e) => e.join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "ipass_data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <Header />
      {showLoaderAdmin && <Loader />}
      <div className="ipass-container container-fluid p-0">
        {/* Header Section */}
        <div className="ipass-header d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4">
          <div className="pageNameDiv">
            <p className="breadcrumb-item">Manage I-Pass</p>

            <img
              src={GreyArrow || "/placeholder.svg"}
              alt="Rapid Car Leasing"
            />
          </div>
          <div className="ipass-actions d-flex flex-column flex-sm-row gap-2 mt-3 mt-md-0">
            <button
              className="btn btn-primary ipass-btn-icon"
              onClick={downloadCSV}
            >
              <Download size={18} />
              Download Excel
            </button>
            <button
              className="btn btn-primary ipass-btn-icon"
              onClick={() => setAddIPassModalOpen(true)}
            >
              <Plus size={18} />
              Add New I-Pass
            </button>
            <button
              className="btn btn-light ipass-btn-icon"
              onClick={() => setUploadModalOpen(true)}
            >
              <Upload size={18} />
              Upload Usage Data
            </button>
          </div>
        </div>

        {/* Statistics Cards - Using the computed statistics data */}
        <div className="row m-0 mb-3">
          <div className="col-md-12">
            <div className="row m-0 h-100">
              <div className="col-md-3 paddingLeft1200 marginClss">
                <div className="analyticsCard">
                  <div>
                    <p>Total I-Passes</p>
                    <h5>{statsData.total}</h5>
                  </div>
                  <div className="ipass-stat-icon blue">
                    <TicketsPlane size={24} />
                  </div>
                </div>
              </div>
              <div className="col-md-3 paddingLeft1200 marginClss">
                <div className="analyticsCard">
                  <div>
                    <p>Avaiable</p>
                    <h5>{statsData.available}</h5>
                  </div>
                  <div className="ipass-stat-icon green">
                    <ShieldCheck size={24} />
                  </div>
                </div>
              </div>

              <div className="col-md-3  paddingLeft1200 marginClss">
                <div className="analyticsCard">
                  <div>
                    <p>Assigned</p>
                    <h5>{statsData.assigned}</h5>
                  </div>
                  <div className="ipass-stat-icon blue">
                    <FilePen size={24} />
                  </div>
                </div>
              </div>
              <div className="col-md-3  paddingLeft1200 marginClss">
                <div className="analyticsCard ">
                  <div>
                    <p>Deactivated</p>
                    <h5>{statsData.lost}</h5>
                  </div>
                  <div className="ipass-stat-icon red">
                    <Info size={24} />
                  </div>
                </div>
              </div>
              <div className="col-md-3 paddingLeft1200 marginClss">
                <div
                  className="analyticsCard position-relative"
                  onClick={() => navigate("/Unassigned_Tolls")}
                >
                  <div>
                    <p>Unassigned Tolls</p>
                    <h5>{statsData.unassigned}</h5>
                  </div>
                  <div className="ipass-stat-icon purple">
                    <FileText size={24} />
                  </div>
                  <p className="showMoreBtn">Show More</p>
                </div>
              </div>
              <div className="col-md-3 paddingLeft1200 marginClss">
                <div
                  className="analyticsCard position-relative"
                  onClick={() => navigate("/Exception_Tolls")}
                >
                  <div>
                    <p>Toll Exceptions</p>
                    <h5>{statsData.notTolls}</h5>
                  </div>
                  <div className="ipass-stat-icon orange">
                    <ShieldOff size={24} />
                  </div>
                  <p className="showMoreBtn">Show More</p>
                </div>
              </div>
              <div className="col-md-3 paddingLeft1200 marginClss">
                <div
                  className="analyticsCard position-relative"
                  onClick={() => navigate("/officeUse_Tolls")}
                >
                  <div>
                    <p>Office Use</p>
                    <h5>{statsData.OfficeUseTolls}</h5>
                  </div>
                  <div className="ipass-stat-icon pink">
                    <ShieldUser size={24} />
                  </div>
                  <p className="showMoreBtn">Show More</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Search & Filter Section */}
        <div className="card ipass-card ipass-filter-card mb-4">
          <div className="card-body">
            <div className="row m-0 g-3">
              <div className="col-md-6">
                <div className="input-group ipass-search-group">
                  <span className="input-group-text">
                    <Search size={18} />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search I-Pass number, car, etc."
                    onChange={handlesearchChange}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <select
                  className="form-select ipass-select"
                  onChange={(e) => handleFilter1(e.target.value)}
                >
                  <option value="20">Status - All</option>
                  <option value="1">Available</option>
                  <option value="2">Assigned</option>
                </select>
              </div>
              {/* <div className="col-md-3">
                <select
                  className="form-select ipass-select"
                  onChange={(e) => handleFilter2(e.target.value)}
                >
                  <option value="1">Sort by - Newest</option>
                  <option value="2">Oldest</option>
                  <option value="3">I-Pass Number (A-Z)</option>
                  <option value="4">I-Pass Number (Z-A)</option>
                </select>
              </div> */}
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="card ipass-card ipass-table-card mb-4">
          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-hover ipass-table mb-0">
                <thead className="table-light">
                  <tr>
                    <th>Sr. No.</th>
                    <th>Created Date</th>
                    <th>Owner</th>
                    <th>I-Pass Number</th>
                    <th>Current State</th>
                    <th>Assigned Car</th>
                    <th>Assigned Date</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems &&
                    currentItems.length > 0 &&
                    currentItems.map((ipass, index) => (
                      <tr key={ipass.id}>
                        <td>{indexOfFirstItem + index + 1}</td>
                        <td>{mondayDayYearFormat(ipass.ipass_date)}</td>
                        <td>
                          {driverData.find(
                            (d) => d.primary_id === ipass.driver_id,
                          )?.name || "RCL"}
                        </td>
                        <td>{ipass.ipass_id}</td>
                        <td>
                          <span
                            className={`badge rounded-pill ${getBadgeClass(
                              ipass.ipass_status,
                            )}`}
                          >
                            {/* {formatStatus(ipass.ipass_status)} */}
                            {ipass.ipass_status == 1
                              ? "Available"
                              : ipass.ipass_status == 2
                                ? "Assigned"
                                : "Inactive"}
                          </span>
                        </td>
                        <td>
                          {ipass?.car_detail?.car_name &&
                          ipass?.car_detail?.car_tagline
                            ? `${ipass.car_detail.car_name} - ${ipass.car_detail.car_tagline}`
                            : ipass?.car_detail?.car_name ||
                              ipass?.car_detail?.car_tagline ||
                              "—"}
                        </td>

                        <td>
                          {ipass.ipass_start_date
                            ? mondayDayYearFormat(ipass.ipass_start_date)
                            : "—"}
                        </td>
                        <td>
                          {console.log(
                            "ipass.ipass_status",
                            ipass.ipass_status,
                          )}
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id={`activation-switch-${ipass.primary_id}`}
                              checked={ipass.ipass_status !== 0}
                              onChange={() =>
                                handleToggleActivation(
                                  ipass,
                                  ipass.ipass_status !== 0 ? 0 : 1,
                                )
                              }
                              disabled={ipass.ipass_status === 2} // Disable toggle if assigned
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`activation-switch-${ipass.primary_id}`}
                            >
                              {ipass.ipass_status !== 0 ? "Active" : "Inactive"}
                            </label>
                          </div>
                        </td>
                        <td>
                          {ipass.ipass_status == 1 && (
                            <>
                              <button
                                className="btn btn-sm btn-link text-primary me-2"
                                onClick={() => handleAssignClick(ipass)}
                              >
                                Assign
                              </button>
                              {ipass.ipass_status === 0 && (
                                <button
                                  className="btn btn-sm btn-link text-danger"
                                  onClick={() => {
                                    setSelectedIPassAction(ipass);
                                    setShowConfirmDelete(true);
                                  }}
                                >
                                  Delete
                                </button>
                              )}
                            </>
                          )}

                          {ipass.ipass_status == 2 && (
                            <>
                              <button
                                className="btn btn-sm btn-link text-warning me-2"
                                onClick={() => {
                                  setSelectedIPassAction(ipass);
                                  setShowConfirmUnassign(true);
                                }}
                              >
                                Unassign
                              </button>
                            </>
                          )}

                          {(ipass.ipass_status == 0 ||
                            ipass.ipass_status == 1) && (
                            <>
                              <button
                                className="btn btn-sm btn-link text-danger"
                                onClick={() => {
                                  setSelectedIPassAction(ipass);
                                  setShowConfirmDelete(true);
                                }}
                              >
                                Delete
                              </button>
                            </>
                          )}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="cust_hist_card_footer">
              <div className="cust_hist_pagination_info">
                {ipassData && ipassData.length > 0 ? (
                  <>
                    Showing{" "}
                    <span className="cust_hist_pagination_bold">
                      {indexOfFirstItem + 1}
                    </span>{" "}
                    to{" "}
                    <span className="cust_hist_pagination_bold">
                      {Math.min(indexOfLastItem, ipassData.length)}
                    </span>{" "}
                    of{" "}
                    <span className="cust_hist_pagination_bold">
                      {ipassData.length}
                    </span>{" "}
                    I-Passes
                  </>
                ) : (
                  <>
                    Showing <span className="cust_hist_pagination_bold">0</span>{" "}
                    I-Passes
                  </>
                )}
              </div>
              <div className="cust_hist_pagination">
                <nav aria-label="Pagination">
                  <ul className="cust_hist_pagination_list">
                    {renderPaginationButtons()}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>

        {/* Add I-Pass Modal */}
        <Modal
          show={addIPassModalOpen}
          onHide={() => setAddIPassModalOpen(false)}
          size="lg"
          centered
          className="ipass-modal"
        >
          <Modal.Header
            style={{ backgroundColor: "var(--primary-color)" }}
            closeButton
          >
            <Modal.Title style={{ color: "#fff" }}>Add New I-Pass</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="container-fluid p-0">
              <div className="">
                {/* Form Section */}
                <div className="col-lg">
                  <div className="ipass-form-container">
                    <h3 className="h5 mb-4">I-Pass Details</h3>

                    <form onSubmit={handleAddIPassSubmit}>
                      <div className="mb-3">
                        <label
                          htmlFor="ipassNumber"
                          className="form-label ipass-form-label"
                        >
                          I-Pass Number <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="ipassNumber"
                          name="ipassNumber"
                          value={formData.ipassNumber}
                          onChange={handleChange}
                          placeholder="Enter unique I-Pass number"
                          required
                        />
                        <div className="form-text ipass-form-text">
                          Must be a unique identifier for this device
                        </div>
                      </div>

                      <div
                        className="mb-3"
                        style={{
                          flexDirection: "row",
                          display: "flex",
                          alignItems: "center",
                          gap: "20px",
                        }}
                      >
                        <div className="col-md-5">
                          <label
                            htmlFor="refund-date"
                            className="accounting-label"
                          >
                            Date
                          </label>
                          <div className="accounting-date-input-wrapper">
                            <DatePicker
                              id="start-date"
                              selected={startDate}
                              onChange={(date) => setStartDate(date)}
                              className="accounting-date-input form-control borderRadiusnew mt-0"
                              placeholderText="MM/DD/YYYY"
                              dateFormat="MM/dd/yyyy"
                              maxDate={new Date()}
                            />
                            <Calendar
                              className="accounting-date-icon"
                              size={18}
                            />
                          </div>
                        </div>

                        <div className="col-md-5">
                          <label
                            htmlFor="ipassStatus"
                            className="form-label ipass-form-label"
                          >
                            Status <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select"
                            id="ipassStatus"
                            name="ipassStatus"
                            value={formData.ipassStatus}
                            onChange={handleChange}
                            required
                          >
                            <option value="" disabled>
                              Select status
                            </option>
                            <option value="1">Active</option>
                            <option value="0">Inactive</option>
                          </select>
                        </div>
                      </div>

                      <div className="mb-3">
                        <label
                          htmlFor="ipassNotes"
                          className="form-label ipass-form-label"
                        >
                          Notes (Optional)
                        </label>
                        <textarea
                          className="form-control"
                          id="ipassNotes"
                          name="ipassNotes"
                          rows="3"
                          value={formData.ipassNotes}
                          onChange={handleChange}
                          placeholder="Add any additional information about this I-Pass"
                        ></textarea>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="light"
              onClick={() => {
                handleCancel();
                setAddIPassModalOpen(false);
              }}
            >
              Cancel
            </Button>
            <Button
              style={{
                backgroundColor: "var(--primary-color)",
                border: "none",
              }}
              onClick={handleAddIPassSubmit}
            >
              Save I-Pass
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Upload Modal - Using the mapped ipassData */}
        <Modal
          show={uploadModalOpen}
          onHide={() => setUploadModalOpen(false)}
          centered
          className="ipass-modal"
        >
          <Modal.Header
            style={{ backgroundColor: "var(--primary-color)" }}
            closeButton
          >
            <Modal.Title style={{ color: "#fff" }}>
              {" "}
              Upload I-Pass Usage Data
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form id="uploadForm33">
              <div className="mb-3">
                <label className="form-label ipass-form-label">
                  Upload CSV File
                </label>
                <div className="ipass-file-upload-container">
                  <div className="text-center">
                    <Upload size={48} className="ipass-file-upload-icon" />
                    <div className="mb-2">
                      <label
                        htmlFor="excel_file"
                        className="text-primary fw-medium cursor-pointer"
                      >
                        Upload a file
                      </label>
                      <span className="ms-1">or drag and drop</span>
                      <input
                        id="excel_file"
                        name="excel_file"
                        type="file"
                        className={`d-none  trio_mandatory  input_field_customPadding form-control`}
                        accept=".csv"
                        onChange={handleFileChange}
                      />
                    </div>
                    <p className="text-muted small">CSV file up to 10MB</p>
                  </div>
                </div>
                {selectedFile && (
                  <div className="mt-2 text-muted small">
                    Selected file: {selectedFile.name}
                  </div>
                )}
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setUploadModalOpen(false)}
            >
              Cancel
            </Button>
            <Button
              style={{
                backgroundColor: "var(--primary-color)",
                border: "none",
              }}
              onClick={() =>
                handleSaveChangesdynamic(
                  "uploadForm33",
                  upload_ipass_excel_data,
                )
              }
            >
              Upload Data
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Assign Modal - Using the vehicles data */}
        <Modal
          show={assignModalOpen}
          onHide={() => setAssignModalOpen(false)}
          className="ipass-modal"
          centered
        >
          <Modal.Header
            style={{ backgroundColor: "var(--primary-color)" }}
            closeButton
          >
            <Modal.Title style={{ color: "#fff" }}>
              Assign I-Pass to Vehicle
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="text-muted">
              Assign I-Pass{" "}
              <span className="fw-medium">{selectedIPass.ipass_id}</span> to a
              vehicle.
            </p>
            <form id="assignForm">
              <div className="mb-3">
                <label
                  htmlFor="selectVehicle"
                  className="form-label ipass-form-label"
                >
                  Select Vehicle
                </label>
                <select
                  id="selectVehicle"
                  name="vehicleId"
                  className="form-select"
                  required
                  onChange={(e) => setCarDataSelected(e.target.value)}
                >
                  <option value="" disabled selected>
                    -- Select a vehicle --
                  </option>
                  {carData &&
                    carData.length > 0 &&
                    carData.map((vehicle) => (
                      <option
                        key={vehicle.primary_id}
                        value={vehicle.primary_id}
                      >
                        {vehicle.car_tagline} ({vehicle.car_name})
                      </option>
                    ))}
                </select>
                {carDataSelectedError && (
                  <div className="text-danger">{carDataSelectedError}</div>
                )}
              </div>
              <div className="mb-3">
                <label
                  htmlFor="assignmentNotes"
                  className="form-label ipass-form-label"
                >
                  Notes (Optional)
                </label>
                <textarea
                  id="assignmentNotes"
                  name="notes"
                  rows="3"
                  className="form-control"
                  placeholder="Add any additional information about this assignment"
                  onChange={(e) => setCarAssignNotes(e.target.value)}
                ></textarea>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setAssignModalOpen(false)}
            >
              Cancel
            </Button>
            <Button
              style={{
                backgroundColor: "var(--primary-color)",
                border: "none",
              }}
              onClick={handleAssignSubmit}
            >
              Confirm Assignment
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Validation Modal */}
        <Modal
          show={showValidationModal}
          onHide={() => setShowValidationModal(false)}
          className="ipass-modal"
        >
          <Modal.Header
            style={{ backgroundColor: "var(--primary-color)" }}
            closeButton
          >
            <Modal.Title style={{ color: "#fff" }}>
              Validation Error
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{validationMessage}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowValidationModal(false)}
            >
              OK
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Success Alert */}
        {successAlert && (
          <div
            className="ipass-alert position-fixed top-0 start-50 translate-middle-x mt-4"
            style={{ zIndex: 1050 }}
          >
            <div className="alert alert-success d-flex align-items-center shadow-sm">
              <div className="ipass-alert-icon me-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
              </div>
              <div className="ipass-alert-message">{successMessage}</div>
              <button
                type="button"
                className="btn-close ms-3"
                onClick={() => setSuccessAlert(false)}
              ></button>
            </div>
          </div>
        )}
        {/* Confirmation Modal for Unassign */}
        <Modal
          show={showConfirmUnassign}
          onHide={() => setShowConfirmUnassign(false)}
          centered
          className="confirmationIpass-modal"
        >
          <Modal.Header
            style={{ backgroundColor: "var(--primary-color)" }}
            closeButton
          >
            <Modal.Title style={{ color: "#fff" }}>
              Confirm Unassign
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              Are you sure you want to unassign I-Pass{" "}
              <strong>{selectedIPassAction?.ipass_id}</strong> from{" "}
              <strong>
                {selectedIPassAction?.car_detail?.car_name || "vehicle"}
              </strong>
              ?
            </p>
            <p className="text-muted">
              This will make the I-Pass available for other vehicles.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="light"
              onClick={() => setShowConfirmUnassign(false)}
            >
              Cancel
            </Button>
            <Button
              variant="warning"
              onClick={() => {
                handleUnassign(selectedIPassAction.primary_id);
                setShowConfirmUnassign(false);
              }}
            >
              Confirm Unassign
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Confirmation Modal for Delete */}
        <Modal
          show={showConfirmDelete}
          onHide={() => setShowConfirmDelete(false)}
          centered
          className="confirmationIpass-modal"
        >
          <Modal.Header
            style={{ backgroundColor: "var(--primary-color)" }}
            closeButton
          >
            <Modal.Title style={{ color: "#fff" }}>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              Are you sure you want to delete I-Pass{" "}
              <strong>{selectedIPassAction?.ipass_id}</strong>?
            </p>
            <p className="text-danger">
              This action cannot be undone. The I-Pass will be permanently
              removed from the system.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="light" onClick={() => setShowConfirmDelete(false)}>
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={() => {
                handleDelete(selectedIPassAction.primary_id);
                setShowConfirmDelete(false);
              }}
            >
              Delete I-Pass
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Confirmation Modal for Activation Toggle */}
        <Modal
          show={showActivationConfirm}
          onHide={() => setShowActivationConfirm(false)}
          centered
          className="confirmationIpass-modal"
        >
          <Modal.Header
            style={{ backgroundColor: "var(--primary-color)" }}
            closeButton
          >
            <Modal.Title style={{ color: "#fff" }}>
              Confirm{" "}
              {newActivationStatus === 1 ? "Activation" : "Deactivation"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {newActivationStatus === 1 ? (
              <p>
                Are you sure you want to activate I-Pass{" "}
                <strong>{ipassToToggle?.ipass_id}</strong>?
              </p>
            ) : (
              <p>
                Are you sure you want to deactivate I-Pass{" "}
                <strong>{ipassToToggle?.ipass_id}</strong>?
              </p>
            )}
            <p className="text-muted">
              {newActivationStatus === 1
                ? "This will make the I-Pass available for assignment to vehicles."
                : "This will make the I-Pass unavailable for assignment until reactivated."}
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="light"
              onClick={() => setShowActivationConfirm(false)}
            >
              Cancel
            </Button>
            <Button
              variant={newActivationStatus === 1 ? "success" : "warning"}
              onClick={() => {
                processActivationToggle(ipassToToggle, newActivationStatus);
                setShowActivationConfirm(false);
              }}
            >
              {newActivationStatus === 1 ? "Activate" : "Deactivate"} I-Pass
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default ManageIPasses;
